var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-center full-width pb-5"},[_c('div',{staticClass:"d-flex align-stretch py-3 px-2 flex-md-row",staticStyle:{"max-width":"1400px"}},[_c('div',{staticClass:"text-justify",staticStyle:{"width":"50%"}},[_c('small')])])])
}]

export { render, staticRenderFns }